<template>
	<v-tooltip location="top" :disabled="!tooltip">
		<template #activator="{ props: tooltipProps }">
			<div v-bind="tooltipProps">
				<MenuContent
					:label="label"
					:options="options"
					:model-value="modelValue"
					@update:model-value="$emit('update:modelValue', $event)"
					@apply="$emit('apply', $event)"
				/>
			</div>
		</template>

		<span>{{ summary }}</span>
	</v-tooltip>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import MenuContent from './MenuContent.vue';
import { StatusFilterValue, FilterOption } from '../../types/components/types';

const props = defineProps<{
	label?: string;
	options: FilterOption[];
	modelValue: StatusFilterValue;
	tooltip?: boolean;
}>();

const emit = defineEmits<{
	'update:modelValue': [value: StatusFilterValue];
	apply: [value: StatusFilterValue];
}>();

/**
 * Tooltip text only
 */
const summary = computed(() => {
	const opt = props.options.find((o) => o.value === props.modelValue.status);
	if (!opt) return '';
	if (!opt.category?.length) return opt.label;
	return `${opt.label} (${props.modelValue.selected.length})`;
});
</script>
